import aiScore from './aiScore.reducer'
export default aiScore